"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Settings/Headings.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);





 const Subheader = ({ children }) => (
  _react2.default.createElement('h2', { className: "settings-page--subheader", __self: this, __source: {fileName: _jsxFileName, lineNumber: 8}},  children )
); exports.Subheader = Subheader

 const Subtitle = ({ children }) => (
  _react2.default.createElement('h4', { className: "settings--profile--subtitle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}},  children )
); exports.Subtitle = Subtitle
